import styled, { css } from 'styled-components';
import { mediaTablet } from 'utils/responsive';

export default styled.p`
  margin-bottom: 2.5vh;
  ${mediaTablet(css`
    margin-bottom: 4.7vh;
  `)}
`;
